import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './styles/darkMode.css';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store/index.ts';
import { PersistGate } from 'redux-persist/integration/react';

// Service Worker Registration
function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then(registration => {
          console.log('SW registered: ', registration);

          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New version available
                  if (confirm('A new version is available! Reload to update?')) {
                    window.location.reload();
                  }
                }
              });
            }
          });
        })
        .catch(registrationError => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
}

// Setup MSW mock service worker in development mode
// This is now disabled to use the real backend API
async function setupMocks() {
  // Disable mock service worker and use real API
  return Promise.resolve();
}

// Initialize the IndexedDB database
async function initializeDatabase() {
  // When using the real API, we don't need to initialize IndexedDB
  // This function is kept for backwards compatibility
  return Promise.resolve();
}

// Initialize the app with MSW and IndexedDB
Promise.all([setupMocks(), initializeDatabase()])
  .then(() => {
    // Register service worker
    registerServiceWorker();

    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </StrictMode>
    );
  })
  .catch(error => {
    console.error('Initialization failed:', error);
  });
